// extracted by mini-css-extract-plugin
export default {"examCard":"ExamSelect_examCard__gDgnC","button":"ExamSelect_button__W2HSj","duration":"ExamSelect_duration__t2V57","code":"ExamSelect_code__fATdM"};